<template>
  <div>
    <div class="content_box">
      <div class="transportation_box_l">
        <el-tooltip
          class="item"
          v-for="(item, index) in circuitData"
          :key="index"
          effect="dark"
          :content="item.name"
          placement="top-start"
        >
          <div class="transportation_box" @click="selectLine(item, index)">
            <el-badge
              :value="item.ordernumber"
              class="item"
              v-if="item.ordernumber > 0"
            >
              <img
                v-if="item.photo"
                :src="item.photo"
                :class="
                  item.id == clickIndex ? 'img_size box_shadow' : 'img_size'
                "
                alt=""
              />
              <img
                v-else
                src="@/assets/img/route1.jpg"
                :class="
                  item.id == clickIndex ? 'img_size box_shadow' : 'img_size'
                "
                alt=""
              />
            </el-badge>
            <img
              v-if="item.photo && item.ordernumber == 0"
              :src="item.photo"
              :class="
                item.id == clickIndex ? 'img_size box_shadow' : 'img_size'
              "
              alt=""
            />
            <img
                   v-if="!item.photo && item.ordernumber == 0"
              src="@/assets/img/route1.jpg"
              :class="
                item.id == clickIndex ? 'img_size box_shadow' : 'img_size'
              "
              alt=""
            />
            <div
              :class="item.id == clickIndex ? 'text_iop color1' : 'text_iop'"
            >
              {{ item.name }}
            </div>
          </div>
        </el-tooltip>
      </div>
    </div>
    <div class="content_box">
      <div class="content_box_title">
        <div class="circle_l"></div>
        <div class="circle_r"></div>
        <div class="text_xl">筛选查询</div>
      </div>
      <!-- 搜索筛选 -->
      <div>
        <div class="table_item_box">
          <div class="table_item_box_l">
            <div class="table_item_box_l_r">
              <div class="fill_in_title">单号</div>

              <input
                v-model="screen.ordernumber"
                type="text"
                placeholder="请输入单号"
                class="table_item_input"
              />
            </div>
          </div>
          <div class="table_item_box_l">
            <div class="table_item_box_l_r">
              <div class="fill_in_title">国内运单号</div>

              <input
                v-model="screen.domesticnumber"
                type="text"
                placeholder="请输入国内运单号"
                class="table_item_input"
              />
            </div>
          </div>

          <div class="table_item_box_s" style="flex-direction: column-reverse">
            <div class="table_item_box_l_r"></div>
            <div class="table_item_box_l_s">
              <el-button type="primary" round @click="scarch" class="round_btn"
                >搜索</el-button
              >
              <el-button round @click="reset">重置</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="content_box">
      <div class="content_box_title">
        <div class="circle_l"></div>
        <div class="circle_r"></div>
        <div class="text_xl">待发货包裹列表</div>
      </div>
      <div class="table_box">
        <el-table
          v-loading="tableLoading"
          :header-cell-style="{ background: '#E7EDF8', color: '#333333' }"
          ref="multipleTable"
          :data="orderData.content"
          tooltip-effect="dark"
          style="width: 100%"
          :row-key="getRowKeys"
          @selection-change="handleSelectionChange"
        >
          <el-table-column
            :reserve-selection="true"
            label-class-name="DisabledSelection"
            type="selection"
            width="100px"
          >
          </el-table-column>
          <el-table-column prop="datecreated" align="center" label="创建日期">
          </el-table-column>
          <el-table-column align="center" prop="ordernumber" label="单号">
          </el-table-column>
          <el-table-column
            align="center"
            prop="domesticnumber"
            label="国内单号"
            show-overflow-tooltip
          >
          </el-table-column>
           <el-table-column align="center" prop="recipientname" label="收件人">
          </el-table-column>

        
          <el-table-column align="center" prop="itemNames" label="包裹内件">
          </el-table-column>
          <el-table-column align="center" prop="stateValue" label="包裹状态">
            <template slot-scope="scope">待发货 </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="address"
            label="详情"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <el-button type="text" @click="details(scope.row.id)"
                >包裹详情</el-button
              >
              <el-button @click="logistics(scope.row)" type="text"
                >物流详情</el-button
              >
            </template>
          </el-table-column>
          <el-table-column align="center" label="联系客服">
            <template slot-scope="scope">
              <el-popover
                placement="bottom"
                title="客服热线"
                width="200"
                trigger="click"
              >
                <div>
                  <div>{{ serviceData }}</div>
                  <div style="white-space: pre-line">{{ serviceDataInfo }}</div>
                </div>

                <el-button
                  slot="reference"
                  @click="service(scope.row.routeid)"
                  type="text"
                  >联系客服</el-button
                >
              </el-popover>
            </template>
          </el-table-column>
        </el-table>

        <div class="paging_box">
          <div class="paging_box_io">
            <div>共{{ orderData.totalElements }}单，</div>
            <div style="color: #5178ffff">
              已选择{{ multipleSelection.length }}单
            </div>
          </div>
          <el-pagination
            @current-change="pageChange"
            background
            layout="prev, pager, next"
            :total="orderData.totalElements"
          >
          </el-pagination>
        </div>
      </div>
      <div class="step_box_s">
        <div class="last_step_l margin_right" @click="shipments">确认发货</div>
      </div>
    </div>
    <el-dialog
      center
      title="请确认发货地址"
      :visible.sync="dialogVisible"
      width="40%"
      :before-close="handleClose"
    >
      <div class="fill_in_list">
        <div class="fill_in_list_l">
          <div class="fill_in_title">发货地址</div>
        </div>
        <div class="input_select">
          {{ selectAddress.province }}{{ selectAddress.city
          }}{{ selectAddress.district }}{{ selectAddress.detailArea }}
          {{ selectAddress.consignee }} {{ selectAddress.mobile }}
        </div>
        <!-- <input
          value="武汉市洪山区光谷大道70号现代光谷世贸中心I栋4楼"
          type="text"
          class="input_select"
          placeholder="请输入国内快递单号"
        /> -->
      </div>
      <el-button type="text" class="text_btn" @click="selectAddressBtn"
        >选择其他地址></el-button
      >
      <span slot="footer" class="dialog-footer">
        <!-- <el-button @click="dialogVisible = false">取 消</el-button> -->
        <el-button
          type="primary"
          :loading="loading"
          class="confirm_btn"
          @click="submitShipments"
          >确认</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      center
      title="选择地址"
      :visible.sync="dialogVisibleAddress"
      width="40%"
      :before-close="handleCloses"
    >
      <div class="flex_box">
        <el-button type="primary" @click="addAddress" plain
          >+新增收货人信息</el-button
        >
      </div>
      <div class="address_model">
        <el-radio
          width="100%"
          size="medium"
          v-model="selectAddresss"
          :label="item"
          v-for="(item, index) in addressList.content"
          :key="index"
        >
          <div class="address_item">
            <div class="user_info_title">
              <div class="user_info">
                <div class="user_name">{{ item.consignee }}</div>
                <el-button
                  v-if="item.isDefault == 1"
                  type="primary"
                  size="mini"
                  round
                  >默认地址</el-button
                >
              </div>
            </div>
            <div class="user_info">
              <div class="title_text_gh">国内收货人：</div>
              <div class="title_details">{{ item.consignee }}</div>
            </div>
            <div class="user_info">
              <div class="title_text_gh">国内电话：</div>
              <div class="title_details">{{ item.mobile }}</div>
            </div>
            <div class="user_info_title">
              <div class="user_info" style="margin: 0">
                <div class="title_text_gh">国内地址：</div>
                <div class="title_details">
                  {{ item.province }}{{ item.city }}{{ item.district
                  }}{{ item.detailArea }}
                </div>
              </div>
            </div>
          </div>
        </el-radio>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleAddress = false">取 消</el-button>
        <el-button type="primary" @click="affirmAddress">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import crudDept from "@/api/userMG";
// import routeimg from '@/assets/img/route1.jpg'
export default {
  data() {
    return {
      tableLoading: "",
      // routeimg:routeimg,
      dialogVisibleAddress: false,
      loading: false,
      isfromchina: 1,
      getRowKeys(row) {
        return row.id;
      },
      orderIds: [],
      sendAddressId: "",
      visibleService: true,
      screen: {
        page: 1,
        size: 10,
        domesticnumber: "",
        ordernumber: "",
        routeid: "",
        state: 10,
      },
      clickIndex: null,
      circuitData: [],
      multipleSelection: [],
      dialogVisible: false,
      orderData: [],
      supportWechat: [],
      serviceDataInfo: "",
      serviceData: "",
      isDefault: 1,
      selectAddress: "",
      addressList: [],
      sendAddressId: "",
      selectAddresss: "",
    };
  },

  created() {
    this.circuit();
    // this.orderList();
    this.addressData();
  },
  methods: {
    // 物流详情
    logistics(item) {
      localStorage.setItem("order", JSON.stringify(item));
      this.$router.push({
        path:
          "/logistics/logistics?code=" +
          item.domesticcarrier +
          "&num=" +
          item.domesticnumber,
      });
    },
    //详情
    details(e) {
      this.$router.push({
        path: "/parcel/parcelDetail?id=" + e + "&name=待发货",
      });
    },
    scarch() {
      this.orderList();
    },
    reset() {
      var clickIndex = this.clickIndex;
      this.screen = {
        page: 1,
        size: 10,
        domesticnumber: "",
        ordernumber: "",
        routeid: clickIndex,
        state: 10,
      };

      this.orderList();
    },
    //分页
    pageChange(e) {
      this.screen.page = e;
      this.orderList();
    },
    //确认发货
    submitShipments() {
      if(this.selectAddress==''){
        this.$message.error('请选择地址');
        return false
      }
      this.loading = true;
      var data = {
        orderIds: this.orderIds,
        sendAddressId: this.selectAddress.id,
        routeId: this.screen.routeid,
      };
      crudDept
        .confirmAddress(data)
        .then((res) => {
          this.loading = false;
          this.dialogVisible = false;
          this.orderIds = [];
          this.$message({
            message: "操作成功",
            type: "success",
          });
          this.$refs.multipleTable.clearSelection();
          this.orderList();
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    //点击确认发货地址
    confirmAddress() {},

    //订单列表
    orderList() {
      this.tableLoading = true;
      crudDept
        .orderList(this.screen)
        .then((res) => {
          this.orderData = res;
          this.tableLoading = false;
        })
        .catch((res) => {
          this.tableLoading = false;
        });
    },

    //选择线路
    selectLine(item, index) {
      this.clickIndex = item.id;
      this.screen.routeid = item.id;
      this.isfromchina = item.type == 4 ? 0 : 1;
      this.orderList();
    },

    //g根据线路获取客服字段
    service(e) {
      if (e) {
        this.circuitw(e);
      }
    },
    circuitw(e) {
      var data = {
        page: 1,
        size: 1,
        id: e,
      };
      crudDept.circuit(data).then((res) => {
        this.serviceData = res.content[0].supportWechat;
        this.serviceDataInfo = res.content[0].description;
      });
    },
    //线路
    circuit() {
      var data = {
        page: 1,
        size: 100,
        state: 10,
        grouptype: 15,
      };
      crudDept.gerRouteNumber(data).then((res) => {
        this.circuitData = res.content;

        this.clickIndex = res.content[0].id;
        this.screen.routeid = res.content[0].id;
        this.isfromchina=res.content[0].type == 4 ? 0 : 1;
        this.orderList();
      });
    },
    //发货
    shipments() {
      if (this.orderIds == "") {
        this.$message({
          message: "请选择确认发货的数据",
          type: "warning",
        });
        return false;
      }
      this.dialogVisible = true;
      this.isDefault=1;
      this.addressData();
    },
    //点击新增地址
    addAddress() {
      this.$router.push({
        path: "/userInfo/addAddress?type=" + this.isfromchina + "&status=0",
      });
    },
    //确认选择的地址
    affirmAddress() {
      this.selectAddress = this.selectAddresss;
      this.dialogVisibleAddress = false;
    },
    //收货地址
    addressData() {
      var data = {
        page: 1,
        size: 50,
        addresstype: this.isfromchina,
        isDefault: this.isDefault,
      };
      crudDept.address(data).then((res) => {
        this.address = res;
        if (this.isDefault == 1) {
          if (res.content.length > 0) {
            this.selectAddress = res.content[0];
            this.sendAddressId = res.content[0].id;
          }
        }
        this.addressList = res;
      });
    },
    //点击选择其他地址
    selectAddressBtn() {
      this.dialogVisibleAddress = true;
      this.isDefault = "";
      this.addressData();
    },
    toggleSelection(rows) {
      if (rows) {
        rows.forEach((row) => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    handleSelectionChange(e) {
      let ids = [];
      e.map((item) => {
        ids.push(item.id);
      });
      this.orderIds = ids;
    },
    todetails() {
      this.$router.push({ path: "/undetermined/batchDetail" });
    },
    productInformation() {
      this.$router.push({ name: "information" });
    },
    handleCloses() {
      this.dialogVisibleAddress = false;
    },
    handleClose(done) {
      this.dialogVisible = false;
      // this.$confirm("确认关闭？")
      //   .then((_) => {
      //     done();
      //   })
      //   .catch((_) => {});
    },
  },
};
</script>
<style scoped>
.transportation_box_l >>> .el-badge__content {
  background-color: #ff6003 !important;
}
.transportation_box_l >>> .el-badge__content.is-fixed {
  top: 0 !important;
  right: 0px !important;
}
.el-badge {
  width: 62px;
  height: 62px;
  display: block;
  margin: 0 auto 10px;
}
.el-table-column--selection .cell {
  padding-left: 10px !important;
  padding-right: 10px !important;
}
.content_box >>> .el-table .DisabledSelection .cell .el-checkbox__inner {
  /* margin-left: -30px; */
  position: relative;
}
.content_box >>> .el-table__header-wrapper .el-checkbox__input::after {
  content: "全选";
  position: absolute;
  margin-left: 10px;
  font-weight: bold;
}

/* .content_box >>>.el-table .DisabledSelection .cell:before{
    content:"全选";
    position:absolute;
    right:0px;
  } */
.checkbox__inner_box {
  width: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.paging_box_io {
  display: flex;
}
.paging_box {
  width: 100%;
  display: flex;
  justify-content: space-between !important;
  align-items: center;

  box-sizing: border-box;
}
.el-checkbox__inner {
  display: inline-block;
  position: relative;
  border: 1px solid #dcdfe6;
  border-radius: 2px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 14px;
  height: 14px;
  background-color: #fff;
  z-index: 1;
  -webkit-transition: border-color 0.25s cubic-bezier(0.71, -0.46, 0.29, 1.46),
    background-color 0.25s cubic-bezier(0.71, -0.46, 0.29, 1.46);
  transition: border-color 0.25s cubic-bezier(0.71, -0.46, 0.29, 1.46),
    background-color 0.25s cubic-bezier(0.71, -0.46, 0.29, 1.46);
}
.el-dialog__footer {
  text-align: center !important;
}
.text_btn {
  margin: 0 auto !important;
  display: block;
}
.confirm_btn {
  margin: 0 auto !important;
  background-color: #5178ff;
  width: 150px;
  height: 44px;
  background: #5178ff;
  box-shadow: 0px 3px 6px rgba(81, 120, 255, 0.1);
  opacity: 1;
  border-radius: 22px;
}
input::-webkit-input-placeholder {
  color: #999999;
}
input::-moz-input-placeholder {
  color: #999999;
}
input::-ms-input-placeholder {
  color: #999999;
}
.fill_in_list_box {
  display: flex;
  flex-wrap: wrap;
}
.fill_in_list {
  /* width: 27%; */
  border-bottom: 1px solid #dedede;
  /* padding-bottom: 10px; */
  padding-right: 10px;
  box-sizing: border-box;
  margin-bottom: 16px;
  margin-right: 22px;
}
.fill_in_list_l {
  display: flex;
  align-items: baseline;
}
.fill_in_title {
  font-size: 15px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 21px;
  color: #333333;
  margin-right: 9px;
}
.fill_in_title_l {
  font-size: 15px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 21px;
  color: #ff0e0e;
}
.numbers_info {
  display: flex;
  align-items: center;
  font-size: 15px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 21px;
  color: #333333;
  margin-bottom: 22px;
}
.el-dialog {
  display: flex;
  flex-direction: column;
  margin: auto !important;
  position: absolute !important;
  top: 50% !important;
  left: 50% !important;
  transform: translate(-50%, -50%) !important;
  /*height:600px;*/
  max-height: calc(100% - 30px) !important;
  max-width: calc(100% - 30px) !important;
}
.el-dialog .el-dialog__body {
  flex: 1;
  overflow: auto;
}
.table_box {
  margin-top: 32px;
}
.el-table td,
.el-table th {
  text-align: center !important;
}
.text_li {
  color: #ffa401 !important;
}
.table_item_box_l_s .el-button.is-round {
  border-radius: 14px;
  width: 110px;
  height: 40px;
}
.table_item_box_s {
  display: flex;
}
.table_item_box_l_s {
  display: flex;
}
.table_item_input >>> .el-input__inner {
  background: none !important;
  outline: none !important;

  border: none;
  color: #fff !important;
  padding: 0;
}
.content_box_title {
  display: flex;
  align-items: center;
}
.circle_l {
  width: 18px;
  height: 18px;
  background: #5178ff;
  border-radius: 50%;
}
.circle_r {
  width: 18px;
  height: 18px;
  background: rgba(81, 120, 255, 0.27);
  border-radius: 50%;
  margin-left: -7px;
}
.text_xl {
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: bold;
  margin-left: 20px;
  color: #333333;
}
.content_box {
  width: 100%;
  height: auto;
  background: #ffffff;
  padding: 38px 58px;
  margin-bottom: 12px;
  box-sizing: border-box;
}
.table_item_box {
  display: flex;
  /* align-items: flex-end; */

  flex-wrap: wrap;
  padding: 25px 0 0;
  box-sizing: border-box;
}
.table_item_box_l {
  margin-right: 30px;
  text-align: left;
}
.table_item_box_l_r {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 20px;
}
.table_item_input {
  width: 180px;
  height: 40px;
  background: #ffffff;

  border: 1px solid #dedede;
  opacity: 1;
  border-radius: 10px;
  margin-left: 10px;
  padding: 0 15px !important;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
}
.input_select {
  width: 100%;
  height: 40px;
  line-height: 40px;
  background: #ffffff;

  border: none;
  opacity: 1;

  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
}
.input_select >>> .el-input__inner {
  border: none !important;
  padding: 0 !important;
  width: 100% !important;
}
.input_select_table {
  padding: 0 !important;
  width: 180px;
  height: 40px;

  opacity: 1;
  border-radius: 10px;
  margin-left: 10px;
  padding: 0 15px !important;
}
.fill_in_title_l {
  font-size: 15px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 21px;
  text-align: left;
  color: #ff0e0e;
}
.transportation_box {
  width: 100px;
  margin: 0 18px 10px;
  cursor: pointer;
}
.transportation_box:hover img {
  box-shadow: 0 5px 18px 0 rgba(0, 0, 0, 0.2);
}
.text_iop {
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 25px;
  color: #2e3136;
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.box_shadow {
  width: 66px !important;
  height: 66px !important;
  box-shadow: 0 5px 18px 0 rgba(0, 0, 0, 0.5);
}
.img_size {
  width: 62px;
  height: 62px;
  background: rgba(0, 0, 0, 0);
  border-radius: 50%;
  display: block;
  margin: 0 auto 10px;
  object-fit: cover;
}
.transportation_box_l {
  display: flex;
  flex-wrap: wrap;
}
.color1 {
  color: #5178ff !important;
}
.step_box_s {
  display: flex;
  justify-content: flex-end;
  margin-top: 58px;
}
.last_step_l {
  width: 150px;
  height: 44px;
  background: #5178ff;
  box-shadow: 0px 3px 6px rgba(81, 120, 255, 0.1);
  opacity: 1;
  line-height: 44px;
  border-radius: 22px;
  margin: 0 20px;
  font-size: 15px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #fff;
  text-align: center;
  cursor: pointer;
}
.address_model {
}
.address_item {
  width: 100%;
  height: auto;
  padding: 32px 44px;
  box-sizing: border-box;
  display: inline-block;

  border: 2px solid #e1e1e1;
  margin-bottom: 20px;
}
.user_info_title {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.user_info {
  display: flex;
  align-items: center;
  margin-bottom: 14px;
}
.user_name {
  margin-right: 20px;
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #333333;
}
.title_text_gh {
  width: 100px;
  font-size: 15px;
  font-family: PingFang SC;
  color: #666666;
}
.title_details {
  font-size: 15px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #333333;
}
.address_model >>> .el-radio__inner {
  width: 26px !important;
  height: 26px !important;
  border-width: 1px !important;
}
.address_model >>> .el-radio__label {
  width: 100% !important;
}
.el-radio {
  width: 100% !important;
  display: flex;
  align-items: center;
  /* justify-content: center; */
}
.flex_box {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 30px;
}
</style>


// WEBPACK FOOTER //
// src/views/undetermined/unShipments.vue